const chaseTimeLineData = [
  {
    day: 1,

  },
  {
    day: 2,

  },
  {
    day: 3,

  },
  {
    day: 5,

  },
  {
    day: 6,

  },
  {
    day: 8,

  },
  {
    day: 10,

  },
  {
    day: 12,

  },
  {
    day: 14,

  },
  {
    day: 16,

  },
  {
    day: 19,

  },
  {
    day: 21,

  },
  {
    day: 23,

  },
  {
    day: 25,

  },
  {
    day: 26,

  },
  {
    day: 28,

  },
  {
    day: 29,

  },
  {
    day: 30,

  },
  {
    day: 31,
  },
];

export default chaseTimeLineData;
